import { CheckIconProps } from "./types";

const CHECK_PATH = "M5 12.5l4.5 4.5L19 7.5";

// Decorative check mark: the state it shows is also given in text or by aria-pressed.
const CheckIcon = ({
    color = "currentColor",
    size,
    strokeWidth,
}: CheckIconProps) => {
    return (
        <svg
            aria-hidden="true"
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <path d={CHECK_PATH} />
        </svg>
    );
};

export default CheckIcon;
